import React from 'react';
import { ReaderPathCheck } from './ReaderPathCheck';
import { Reveal } from './Reveal';
import { PathThread } from './PathThread';
export function ReaderValue() {
  const readerStates = ['Interested, but not ready for a call', 'Trying to apply one idea', 'Needs the right next step'];
  return <section className="py-24 px-6 max-w-4xl mx-auto relative" data-id="element-455">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2" data-id="element-456">
        <PathThread data-id="element-457" />
      </div>

      <div className="text-center mb-20" data-id="element-458">
        <Reveal data-id="element-459">
          <h2 className="text-3xl md:text-5xl font-serif text-navy mb-8 leading-tight" data-id="element-460">
            Some readers are not ready to buy. <br data-id="element-461" />
            <span className="italic text-seaglass" data-id="element-462">
              But they are ready to keep going.
            </span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-463">
          <div className="text-lg text-text-muted leading-relaxed max-w-2xl mx-auto space-y-6" data-id="element-464">
            <p data-id="element-465">
              A reader can be interested without being ready to book a call.
            </p>
            <ul className="space-y-3 text-left max-w-lg mx-auto bg-white p-6 rounded-2xl shadow-[0_8px_20px_-12px_rgba(26,40,56,0.1)] border border-gray-100" data-id="element-466">
              <li className="flex items-start gap-3" data-id="element-467">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-468"></div>
                They may need to understand where they fit.
              </li>
              <li className="flex items-start gap-3" data-id="element-469">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-470"></div>
                They may need to try the idea in their own situation.
              </li>
              <li className="flex items-start gap-3" data-id="element-471">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-472"></div>
                They may need to see whether the framework applies to their
                team.
              </li>
              <li className="flex items-start gap-3" data-id="element-473">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-474"></div>
                They may need language for the problem before they are ready to
                ask for help.
              </li>
            </ul>
            <p className="font-serif text-2xl text-navy pt-6" data-id="element-475">
              The path after the book gives them a useful next step before they
              are ready for a sales conversation.
            </p>
          </div>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-24" data-id="element-476">
        {readerStates.map((state, idx) => <Reveal key={idx} delay={0.1 * idx} data-id="element-477">
            <div className="bg-white border border-gray-100 rounded-2xl p-8 text-center shadow-[0_12px_24px_-12px_rgba(26,40,56,0.15)] hover:-translate-y-1 transition-transform duration-300 flex items-center justify-center min-h-[120px]" data-id="element-478">
              <span className="font-serif text-lg text-navy" data-id="element-479">{state}</span>
            </div>
          </Reveal>)}
      </div>

      <Reveal delay={0.2} data-id="element-480">
        <div id="quick-check-3" className="scroll-mt-32" data-id="element-481">
          <ReaderPathCheck questionId="q4.apply.thisWeek" checkLabel="Quick Check · 3 of 8" confirmationText="Saved. This helps check whether the book gives readers a useful next step." data-id="element-482" />
        </div>
      </Reveal>
    </section>;
}